export default "/images/vendor/@coreui/icons/svg/flag/cif-km.svg?aa3e3ac723523c00500f72afdcacbe16";